import { bindActionCreators } from "redux";
import { call, put, take } from "redux-saga/effects";

import * as apiCaller from "../../api/apiCaller";

export const GET_LIST_PARTNER_SWITCHBOARD = "GET_LIST_PARTNER_SWITCHBOARD";
export const GET_LIST_PARTNER_SWITCHBOARD_ERROR =
  "GET_LIST_PARTNER_SWITCHBOARD_ERROR";
export const GET_LIST_PARTNER_SWITCHBOARD_SUCCESS =
  "GET_LIST_PARTNER_SWITCHBOARD_SUCCESS";

export const COUNT_LIST_PARTNER_SWITCHBOARD = "COUNT_LIST_PARTNER_SWITCHBOARD";
export const COUNT_LIST_PARTNER_SWITCHBOARD_ERROR =
  "COUNT_LIST_PARTNER_SWITCHBOARD_ERROR";
export const COUNT_LIST_PARTNER_SWITCHBOARD_SUCCESS =
  "COUNT_LIST_PARTNER_SWITCHBOARD_SUCCESS";

export const DELETE_PARTNER_SWITCHBOARD = "DELETE_PARTNER_SWITCHBOARD";
export const DELETE_PARTNER_SWITCHBOARD_ERROR =
  "DELETE_PARTNER_SWITCHBOARD_ERROR";
export const DELETE_PARTNER_SWITCHBOARD_SUCCESS =
  "DELETE_PARTNER_SWITCHBOARD_SUCCESS";

export const EDIT_PARTNER_SWITCHBOARD = "EDIT_PARTNER_SWITCHBOARD";
export const EDIT_PARTNER_SWITCHBOARD_SUCCESS =
  "EDIT_PARTNER_SWITCHBOARD_SUCCESS";
export const EDIT_PARTNER_SWITCHBOARD_ERROR = "EDIT_PARTNER_SWITCHBOARD_ERROR";

export const ADD_PARTNER_SWITCHBOARD = "ADD_PARTNER_SWITCHBOARD";
export const ADD_PARTNER_SWITCHBOARD_SUCCESS =
  "ADD_PARTNER_SWITCHBOARD_SUCCESS";
export const ADD_PARTNER_SWITCHBOARD_ERROR = "ADD_PARTNER_SWITCHBOARD_ERROR";
/**
 * Reducer
 */

const initialState = {
  partnerSwitchboards: [],
  partnerSwitchboard: {},
  error: false,
  count: 0,
  loading: false,
};

export const partnerSwitchboardReducer = (state = initialState, action) => {
  switch (action.type) {
    //get list
    case GET_LIST_PARTNER_SWITCHBOARD:
      return {
        ...state,
        loading: true,
      };
    case GET_LIST_PARTNER_SWITCHBOARD_SUCCESS:
      return {
        ...state,
        loading: false,
        partnerSwitchboards: action.payload,
      };
    case GET_LIST_PARTNER_SWITCHBOARD_ERROR:
      return {
        ...state,
        error: action.error,
        loading: true,
      };
    //count list
    case COUNT_LIST_PARTNER_SWITCHBOARD:
      return {
        ...state,
        loading: true,
      };
    case COUNT_LIST_PARTNER_SWITCHBOARD_SUCCESS:
      return {
        ...state,
        loading: false,
        count: action.payload,
      };
    case COUNT_LIST_PARTNER_SWITCHBOARD_ERROR:
      return {
        ...state,
        error: action.error,
        loading: false,
      };
    //delete list
    case DELETE_PARTNER_SWITCHBOARD:
      return {
        ...state,
      };
    case DELETE_PARTNER_SWITCHBOARD_SUCCESS:
      return {
        ...state,
        partnerSwitchboard: action.payload,
      };
    case DELETE_PARTNER_SWITCHBOARD_ERROR:
      return {
        ...state,
        error: action.error,
      };
    //EDIT
    case EDIT_PARTNER_SWITCHBOARD:
      return {
        ...state,
      };
    case EDIT_PARTNER_SWITCHBOARD_SUCCESS:
      return {
        ...state,
        partnerSwitchboard: action.payload,
      };
    case EDIT_PARTNER_SWITCHBOARD_ERROR:
      return {
        ...state,
        error: action.error,
      };
    //add
    case ADD_PARTNER_SWITCHBOARD:
      return {
        ...state,
      };
    case ADD_PARTNER_SWITCHBOARD_SUCCESS:
      return {
        ...state,
        partnerSwitchboard: action.payload,
      };
    case ADD_PARTNER_SWITCHBOARD_ERROR:
      return {
        ...state,
        error: action.error,
      };
    default:
      return state;
  }
};

/**
 * Action
 */
export const getListPartnerSwitchBoard = (order, limit, skip, where) => ({
  type: GET_LIST_PARTNER_SWITCHBOARD,
  data: {
    order,
    limit,
    skip,
    where,
  },
});

export const countListPartnerSwitchBoard = (where) => ({
  type: COUNT_LIST_PARTNER_SWITCHBOARD,
  data: {
    where,
  },
});

export const deletePartnerSwitchBoard = (id, filters) => ({
  type: DELETE_PARTNER_SWITCHBOARD,
  data: {
    id,
    filters,
  },
});

export const editPartnerSwitchBoard = (id, name, ip, port, filters) => ({
  type: EDIT_PARTNER_SWITCHBOARD,
  data: {
    id,
    name,
    ip,
    port,
    filters,
  },
});

export const addPartnerSwitchBoard = (name, ip, port, filters) => ({
  type: ADD_PARTNER_SWITCHBOARD,
  data: {
    name,
    ip,
    port,
    filters,
  },
});

export const mapActionsToProps = (dispatch) => {
  return bindActionCreators(
    {
      getListPartnerSwitchBoard,
      deletePartnerSwitchBoard,
      editPartnerSwitchBoard,
      addPartnerSwitchBoard,
      countListPartnerSwitchBoard,
    },
    dispatch
  );
};

/**
 * Apis
 */

const getListPartnerSwitchBoardApi = (
  order,
  limit,
  skip,
  where,
  include,
  fields
) => {
  return apiCaller.getLogs("/cloud-pbx/trunk-partner", {
    order,
    limit,
    skip,
    ...where,
    ...include,
    ...fields,
  });
};

const countListPartnerSwitchBoardApi = (where) => {
  return apiCaller.getData("/cloud-pbx/trunk-partner/count", { ...where });
};

const deletePartnerSwitchBoardApi = (id) => {
  return apiCaller.del(`/cloud-pbx/trunk-partner/${id}`);
};

const addPartnerSwitchBoardApi = (name, ip, port) => {
  return apiCaller.post("/cloud-pbx/trunk-partner", { name, ip, port });
};

const editPartnerSwitchBoardApi = (id, name, ip, port) => {
  return apiCaller.put(`/cloud-pbx/trunk-partner/${id}`, { name, ip, port });
};

/**
 * sagas
 */

export const getListPartnerSwitchBoardFlow = function* () {
  while (true) {
    const action = yield take(GET_LIST_PARTNER_SWITCHBOARD);
    try {
      const res = yield call(
        getListPartnerSwitchBoardApi,
        action.data.order,
        action.data.limit,
        action.data.skip,
        action.data.where
      );
      yield put({
        type: GET_LIST_PARTNER_SWITCHBOARD_SUCCESS,
        payload: { ...res.data },
      });
    } catch (error) {
      yield put({ type: GET_LIST_PARTNER_SWITCHBOARD_ERROR, error });
    }
  }
};

export const deletePartnerSwitchBoardFlow = function* () {
  while (true) {
    const action = yield take(DELETE_PARTNER_SWITCHBOARD);
    try {
      const res = yield call(deletePartnerSwitchBoardApi, action.data.id);
      yield put({
        type: DELETE_PARTNER_SWITCHBOARD_SUCCESS,
        payload: { ...res.data },
      });
      const resGet = yield call(
        getListPartnerSwitchBoardApi,
        action.data.filters.order,
        action.data.filters.limit,
        action.data.filters.skip,
        action.data.filters.where
      );
      yield put({
        type: GET_LIST_PARTNER_SWITCHBOARD_SUCCESS,
        payload: { ...resGet.data },
      });
      const resCount = yield call(
        countListPartnerSwitchBoardApi,
        action.data.filters.where
      );
      yield put({
        type: COUNT_LIST_PARTNER_SWITCHBOARD_SUCCESS,
        payload: { ...resCount.data },
      });
    } catch (error) {
      yield put({ type: DELETE_PARTNER_SWITCHBOARD_ERROR, error });
    }
  }
};
export const editPartnerSwitchBoardFlow = function* () {
  while (true) {
    const action = yield take(EDIT_PARTNER_SWITCHBOARD);
    try {
      const res = yield call(
        editPartnerSwitchBoardApi,
        action.data.id,
        action.data.name,
        action.data.ip,
        action.data.port
      );
      yield put({
        type: EDIT_PARTNER_SWITCHBOARD_SUCCESS,
        payload: { ...res.data },
      });
      const resGet = yield call(
        getListPartnerSwitchBoardApi,
        action.data.filters.order,
        action.data.filters.limit,
        action.data.filters.skip,
        action.data.filters.where
      );
      yield put({
        type: GET_LIST_PARTNER_SWITCHBOARD_SUCCESS,
        payload: { ...resGet.data },
      });
      const resCount = yield call(
        countListPartnerSwitchBoardApi,
        action.data.filters.where
      );
      yield put({
        type: COUNT_LIST_PARTNER_SWITCHBOARD_SUCCESS,
        payload: { ...resCount.data },
      });
    } catch (error) {
      yield put({ type: EDIT_PARTNER_SWITCHBOARD_ERROR, error });
    }
  }
};
export const addPartnerSwitchBoardFlow = function* () {
  while (true) {
    const action = yield take(ADD_PARTNER_SWITCHBOARD);
    try {
      const res = yield call(
        addPartnerSwitchBoardApi,
        action.data.name,
        action.data.ip,
        action.data.port
      );
      yield put({
        type: ADD_PARTNER_SWITCHBOARD_SUCCESS,
        payload: { ...res.data },
      });
      const resGet = yield call(
        getListPartnerSwitchBoardApi,
        action.data.filters.order,
        action.data.filters.limit,
        action.data.filters.skip,
        action.data.filters.where
      );
      yield put({
        type: GET_LIST_PARTNER_SWITCHBOARD_SUCCESS,
        payload: { ...resGet.data },
      });
      const resCount = yield call(
        countListPartnerSwitchBoardApi,
        action.data.filters.where
      );
      yield put({
        type: COUNT_LIST_PARTNER_SWITCHBOARD_SUCCESS,
        payload: { ...resCount.data },
      });
    } catch (error) {
      yield put({ type: ADD_PARTNER_SWITCHBOARD_ERROR, error });
    }
  }
};

export const countPartnerSwitchBoardFlow = function* () {
  while (true) {
    const action = yield take(COUNT_LIST_PARTNER_SWITCHBOARD);
    try {
      const res = yield call(countListPartnerSwitchBoardApi, action.data.where);
      yield put({
        type: COUNT_LIST_PARTNER_SWITCHBOARD_SUCCESS,
        payload: { ...res.data },
      });
    } catch (error) {
      yield put({ type: COUNT_LIST_PARTNER_SWITCHBOARD_ERROR, error });
    }
  }
};
